import React, { useEffect } from "react";
import HotelPartnersCarousel from "../../components/theme-five/hotel-partners-carousel";
import "./style.css";
// import { Helmet } from "react-helmet";

const XcelLocalPartners = () => {
  useEffect(() => {
    document.title = "Commercial Laundry & Linen Service — Canary Wharf, Stratford & Docklands | Xcel Dry Cleaners";
  }, []);

  const sendWA = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const num = "442074732846";
    const form = e.target as HTMLFormElement;
    const name = (form.elements.namedItem('name') as HTMLInputElement).value;
    const number = (form.elements.namedItem('number') as HTMLInputElement).value;
    const email = (form.elements.namedItem('email') as HTMLInputElement).value;
    const biz = (form.elements.namedItem('biz') as HTMLInputElement).value;
    const type = (form.elements.namedItem('type') as HTMLSelectElement).value;
    const area = (form.elements.namedItem('area') as HTMLInputElement).value;
    const need = (form.elements.namedItem('need') as HTMLTextAreaElement).value;
    
    const msg = "New laundry enquiry%0A%0A" + "Name: " + encodeURIComponent(name) + "%0A" + "Number: " + encodeURIComponent(number) + "%0A" + "Email: " + encodeURIComponent(email) + "%0A" + "Business: " + encodeURIComponent(biz) + "%0A" + "Type: " + encodeURIComponent(type) + "%0A" + "Area: " + encodeURIComponent(area) + "%0A" + "Needs: " + encodeURIComponent(need);
    window.open("https://wa.me/" + num + "?text=" + msg, "_blank");
  };

  return (
    <div className="xcel-partners-page">
      {/* <Helmet>
        <meta name="description" content="Contract laundry and uniform cleaning for hotels, gyms, salons and restaurants across Newham, Canary Wharf, Stratford and Docklands. Free collection & delivery, 48h turnaround. Call 020 7473 2846 for a quote." />
        <link rel="canonical" href="https://xceldrycleaners.co.uk/local-partnerships" />
        <meta property="og:title" content="Commercial Laundry & Linen Service — East London | Xcel Dry Cleaners" />
        <meta property="og:description" content="Uniforms and linen collected, cleaned and delivered on a fixed schedule. Call for the best price. Serving Canary Wharf, Stratford, Newham & Docklands." />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta name="theme-color" content="#5A2A6E" />
        <script type="application/ld+json">
          {`
            {
              "@context":"https://schema.org",
              "@type":"DryCleaningOrLaundry",
              "name":"Xcel Dry Cleaners",
              "description":"Commercial laundry, linen and uniform cleaning with free collection and delivery across East London.",
              "url":"https://xceldrycleaners.co.uk/local-partnerships",
              "telephone":"+442074732846",
              "address":{"@type":"PostalAddress","streetAddress":"17 Western Gateway","addressLocality":"London","postalCode":"E16 1AQ","addressCountry":"GB"},
              "areaServed":["Newham","Canary Wharf","Stratford","Docklands","Royal Docks","East Ham","Barking","Walthamstow"],
              "aggregateRating":{"@type":"AggregateRating","ratingValue":"4.2","bestRating":"5"},
              "priceRange":"££",
              "openingHours":"Mo-Sa 08:00-19:00"
            }
          `}
        </script>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Archivo:wdth,wght@62..125,400..900&family=IBM+Plex+Mono:wght@400;500&family=Playfair+Display:ital,wght@0,500;0,700;1,500&display=swap" rel="stylesheet" />
      </Helmet> */}

      <section className="hero">
        <div className="wrap">
          <div className="eyebrow">Commercial laundry · East London</div>
          <h1>Commercial laundry &amp; linen service, <em>collected and handled</em></h1>
          <p>Xcel is a contract commercial laundry service running scheduled uniform cleaning and linen collection for hotels, gyms, salons and restaurants across Newham, Canary Wharf, Stratford and the Docklands. Free collection and delivery, one named contact, and a WhatsApp line that actually answers.</p>
          <div className="btns">
            <a className="btn btn-wa" href="https://wa.me/442074732846?text=Hi%2C%20I%27d%20like%20a%20quote%20for%20my%20business%20laundry." target="_blank" rel="noopener noreferrer">◉ Get a quote on WhatsApp</a>
            <a className="btn btn-line" href="#enquire">Send an enquiry →</a>
          </div>
          <div className="trust">
            <div><b>50+</b>years in laundry &amp; dry cleaning</div>
            <div><b>Free</b>collection &amp; delivery</div>
            <div><b>48 hr</b>standard turnaround</div>
            <div><b>4.2★</b>customer rating</div>
          </div>
        </div>
      </section>

      <section id="serve">
        <div className="wrap">
          <div className="lbl">What we handle</div>
          <h2>Built for businesses that can't run out of clean</h2>
          <p className="lede">Whatever the trade calls it — commercial laundry, contract laundry, linen hire — if your linen or uniforms run on a cycle, we put that cycle on a fixed schedule so you never think about it again.</p>
          <div className="cards">
            <div className="card"><div className="no">01</div><h3>Hotel &amp; Aparthotel Linen Service</h3><p>Bed linen, towels, robes and front-of-house uniforms, collected and delivered on a hotel laundry schedule — plus guest wash &amp; fold and dry cleaning you can offer as a service.</p></div>
            <div className="card"><div className="no">02</div><h3>Gym &amp; Studio Towel Service</h3><p>Daily towel laundry cycles, staff kit and equipment covers. High volume, tight turnaround, no drama.</p></div>
            <div className="card"><div className="no">03</div><h3>Salon &amp; Spa Towel Cleaning</h3><p>Gowns, capes and towels on a professional laundry cycle. Colour-safe washing, whites kept genuinely white.</p></div>
            <div className="card"><div className="no">04</div><h3>Restaurant &amp; Chef Whites Laundry</h3><p>Chef whites, aprons, table linen and napkins — with grease and stain treatment as standard on every commercial wash.</p></div>
            <div className="card"><div className="no">05</div><h3>Staff Uniform Cleaning for Offices</h3><p>Staff dry cleaning as a workplace perk, plus concierge collection for tenants and coworking members.</p></div>
            <div className="card"><div className="no">06</div><h3>Serviced Apartment Linen Change</h3><p>Linen turnaround between guests, timed to match your check-outs.</p></div>
          </div>
        </div>
      </section>

      <section className="why" id="how">
        <div className="wrap">
          <div className="lbl">The account pledge</div>
          <h2>How a partnership works</h2>
          <p className="lede">No portals, no per-order admin. Five things, agreed once.</p>
          <div className="steps">
            <div className="step"><h4>Fixed schedule</h4><p>Collection and delivery days agreed at the start and kept.</p></div>
            <div className="step"><h4>One contact</h4><p>A named person on WhatsApp — not a ticket queue.</p></div>
            <div className="step"><h4>Counted both ways</h4><p>Itemised count out, itemised count back. Nothing goes missing quietly.</p></div>
            <div className="step"><h4>Free re-clean</h4><p>Anything back wrong is redone at no charge, no argument.</p></div>
            <div className="step"><h4>One invoice</h4><p>Monthly billing. No chasing, no per-order paperwork.</p></div>
          </div>
        </div>
      </section>

      <section className="offer">
        <div className="wrap">
          <div className="lbl">Straight to a price</div>
          <h2>Call us for the best price</h2>
          <p>Tell us what you need cleaned and how often, and we'll give you a quote — no obligation. Volume, uniforms, linen or a mix: we price it to your schedule, not off a generic list.</p>
          <a className="btn btn-wa" href="https://wa.me/442074732846?text=Hi%2C%20I%27d%20like%20a%20quote%20for%20my%20business%20laundry." target="_blank" rel="noopener noreferrer">◉ Get your quote on WhatsApp</a>
        </div>
      </section>

      <section id="enquire">
        <div className="wrap">
          <div className="contactgrid">
            <div>
              <div className="lbl">Get a quote</div>
              <h2>Tell us what you need</h2>
              <p className="lede" style={{ marginBottom: "22px" }}>Fill this in and we'll come back within the hour during working times. Prefer to talk? WhatsApp is fastest.</p>
              <form onSubmit={sendWA}>
                <div className="field"><label htmlFor="name">Your name</label><input id="name" name="name" required placeholder="e.g. John Doe" /></div>
                <div className="field"><label htmlFor="number">Phone number</label><input id="number" name="number" type="tel" required placeholder="e.g. 07..." /></div>
                <div className="field"><label htmlFor="email">Email address</label><input id="email" name="email" type="email" required placeholder="e.g. name@company.com" /></div>
                <div className="field"><label htmlFor="biz">Business name</label><input id="biz" name="biz" required placeholder="e.g. The Gantry London" /></div>
                <div className="field"><label htmlFor="type">Type of business</label>
                  <select id="type" name="type" required>
                    <option value="">Select…</option>
                    <option>Hotel / aparthotel</option><option>Gym / studio</option><option>Salon / spa</option>
                    <option>Restaurant</option><option>Office / coworking</option><option>Serviced apartments</option><option>Other</option>
                  </select></div>
                <div className="field"><label htmlFor="area">Area</label><input id="area" name="area" required placeholder="e.g. Canary Wharf" /></div>
                <div className="field"><label htmlFor="need">What do you need cleaned?</label><textarea id="need" name="need" placeholder="e.g. ~200 towels a day, staff uniforms weekly"></textarea></div>
                <button className="send" type="submit">Send enquiry via WhatsApp →</button>
                <p className="formnote">By sending, a pre-filled WhatsApp message opens so you can hit send. No data is stored on this page.</p>
              </form>
            </div>
            <div className="aside">
              <h3>Reach us directly</h3>
              <div className="row"><span className="k">WhatsApp</span><a href="https://wa.me/442074732846" target="_blank" rel="noopener noreferrer">+44 20 7473 2846</a></div>
              <div className="row"><span className="k">Phone</span><a href="tel:+442074732846">020 7473 2846</a></div>
              <div className="row"><span className="k">Email</span><a href="mailto:info@xceldrycleaners.co.uk">info@xceldrycleaners.co.uk</a></div>
              <div className="row"><span className="k">Address</span><span>17 Western Gateway, London E16 1AQ</span></div>
              <div className="row"><span className="k">Hours</span><span>Mon to Fri - 9am to 7pm <br /> Sat  - 10am - 5pm <br /> Sun - Closed</span></div>
              <h3 style={{ marginTop: "28px" }}>Coverage area</h3>
              <div className="areatags">
                <span>Newham</span><span>Canary Wharf</span><span>Stratford</span><span>Docklands</span>
                <span>Royal Docks</span><span>East Ham</span><span>Barking</span><span>Walthamstow</span>
              </div>
              <p style={{ fontSize: "14px", color: "var(--muted)", marginTop: "18px" }}>Own vans, own routes. Inside this ring you get a fixed collection window — not a "sometime today".</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cases" id="cases">
        <div className="wrap">
          <div className="lbl">Proof, not promises</div>
          <h2>Businesses we already look after</h2>
          <HotelPartnersCarousel />
        </div>
      </section>

      <section>
        <div className="wrap" style={{ maxWidth: "820px" }}>
          <div className="lbl">Common questions</div>
          <h2>Before you get in touch</h2>
          <div style={{ marginTop: "26px" }}>
            <details open><summary>Which areas do you cover?</summary><p>We run free collection and delivery across Newham, Canary Wharf, Stratford, the Docklands, Royal Docks, East Ham, Barking and Walthamstow, from our base at 17 Western Gateway, E16. If you're near the edge of that, ask — we may still reach you.</p></details>
            <details><summary>How much does it cost?</summary><p>Pricing depends on volume, how often you need collection, and the mix of linen and uniforms. Call 020 7473 2846 or WhatsApp us with a rough idea of what you need and we'll give you a no-obligation quote priced to your schedule.</p></details>
            <details><summary>How quickly do you turn things around?</summary><p>Standard turnaround is 48 hours, with free collection and delivery. For hotels and gyms on daily cycles we agree fixed collection and delivery windows that fit your operation.</p></details>
            <details><summary>How do we place and manage orders?</summary><p>Through one named contact on WhatsApp. No portal, no ticket queue. You get an itemised count out and back, and a single monthly invoice.</p></details>
            <details><summary>What if something comes back wrong?</summary><p>We re-clean it free, no argument. That's part of the account pledge, backed by 50+ years in the trade.</p></details>
          </div>
        </div>
      </section>
    </div>
  );
};

export default XcelLocalPartners;
